var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{tag:"component",staticClass:"d-inline-block loader",class:{ 'loading': _vm.loading }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }